'use client';
import { jsx } from 'react/jsx-runtime';
import { dataAttr, cx } from '@chakra-ui/utils';
import { useSelectContext, useSelectStyles } from './select-context.mjs';
import { chakra } from '../system/factory.mjs';

const Icon = (props) => /* @__PURE__ */ jsx(
  chakra.svg,
  {
    role: "presentation",
    viewBox: "0 0 24 24",
    className: "chakra-select__icon",
    focusable: "false",
    "aria-hidden": "true",
    ...props,
    style: {
      width: "1em",
      height: "1em",
      color: "currentColor"
    },
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
      }
    )
  }
);
const NativeSelectIcon = (props) => {
  const { asChild, ...rest } = props;
  const fieldProps = useSelectContext();
  const styles = useSelectStyles();
  return /* @__PURE__ */ jsx(
    chakra.div,
    {
      ...rest,
      "data-disabled": dataAttr(fieldProps.disabled),
      className: cx("chakra-select__icon-wrapper", props.className),
      __css: styles.icon,
      children: /* @__PURE__ */ jsx(Icon, {})
    }
  );
};
NativeSelectIcon.displayName = "NativeSelectIcon";

export { NativeSelectIcon };
